import { connect } from 'react-redux';
import Cart from '../components/Cart';
import { onChangeParameter } from '../actions/QuoteActions';

const mapStateToProps = state => ({
  parameters: state.get('parameters').toJS(),
  quote     : state.get('quote').toJS(),
  quoteStep : state.get('quoteStep'),
  cart      : state.get('cart'),
});

const mapActionsToProps = {
  onChangeParameter,
};

export default connect(mapStateToProps, mapActionsToProps)(Cart);
